<template>
  <div>
    <!--搜索栏-->
    <searchBar
      :search-form="searchForm"
      name
      btn-add
      @handleAdd="dialogFormVisible = true"
      @handleSearch="getData"
    ></searchBar>

    <!--表格-->
    <el-table :data="tableData" border>
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="60"
      ></el-table-column>
      <el-table-column
        v-for="(item, index) in tableHeader"
        :key="index"
        :label="item"
        :prop="index"
        align="center"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="240">
        <template slot-scope="scope">
          <el-button @click="manManager(scope.row)" type="text" size="mini">
            维护干部信息
          </el-button>
          <el-button @click="handleEdit(scope.row)" type="text" size="mini">
            编辑
          </el-button>
          <el-button
            @click="handleEnabled(scope.row)"
            type="text"
            :style="{ color: scope.row.status === 1 ? 'red' : '' }"
            size="mini"
          >
            {{ scope.row.status === 1 ? "禁用" : "启用" }}
          </el-button>
          <el-button
            @click="handleDelete(scope.row)"
            type="text"
            style="color:red"
            size="mini"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="block">
      <el-pagination
        class="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="size"
        layout=" prev, pager, next, jumper, sizes"
        :total="totalElements"
      ></el-pagination>
    </div>
    <!-- 维护干部信息 -->
    <el-dialog :visible.sync="manDialog" title="维护干部信息">
      <el-form
        :model="manForm"
        ref="manForm"
        label-width="60px"
        class="demo-dynamic"
      >
        <el-form-item
          prop="name"
          label="姓名"
          :rules="[
            { required: true, message: '请输干部姓名', trigger: 'blur' },
          ]"
        >
          <el-input v-model="manForm.name"></el-input>
        </el-form-item>
        <el-form-item
          prop="phone"
          label="电话"
          :rules="[
            { required: true, message: '请输入电话号码', trigger: 'blur' },
          ]"
        >
          <el-input v-model="manForm.value"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeManDialog">
          取消
        </el-button>
        <el-button @click="addManDialog">提交</el-button>
      </div>
    </el-dialog>

    <!--新增Dialog-->
    <el-dialog
      title="添加社区/村"
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="120px"
        label-suffix="："
        label-position="right"
        :status-icon="true"
      >
        <el-form-item label="名称" prop="name" label-width="120px">
          <el-input
            v-model="form.name"
            size="medium"
            placeholder="名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="类型"
          label-width="120px"
          prop="type"
          style="text-align: left"
        >
          <el-radio v-model="form.type" :label="1" border>社区</el-radio>
          <el-radio v-model="form.type" :label="2" border>村</el-radio>
          <el-radio v-model="form.type" :label="3" border>机关</el-radio>
        </el-form-item>
        <el-form-item
          label="管理员用户名"
          v-if="!isEdit"
          prop="username"
          label-width="120px"
        >
          <el-input
            v-model="form.username"
            size="medium"
            :disabled="isEdit"
            placeholder="管理员用户名"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="管理员密码"
          v-if="!isEdit"
          prop="password"
          label-width="120px"
        >
          <el-input
            v-model="form.password"
            show-password
            size="medium"
            placeholder="管理员密码"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="管理员手机号"
          v-if="!isEdit"
          prop="mobile'"
          label-width="120px"
        >
          <el-input
            v-model="form.mobile"
            type="number"
            :maxlength="11"
            size="medium"
            placeholder="管理员手机号"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "@/assets/http/utils.ts"
import { resetObject } from "@/utils"
import { pick } from "lodash"

export default {
  name: "communityInfo",

  data() {
    return {
      // 页面初始数据
      totalElements: 10,
      totalPages: 1,
      size: 10,
      page: 1,

      // 搜索栏初始化
      searchForm: {
        name: "",
        status: "",
        mobile: "",
        idCard: "",
      },

      // 表头初始化
      tableHeader: {
        name: "名称",
        typeName: "类型",
        username: "管理员用户名",
        statusName: "状态",
      },

      // 表格数据
      tableData: [],

      // dialog可见性
      dialogFormVisible: false,

      // 新增表单
      form: {
        uid: "",
        name: "",
        type: "",
        username: "",
        password: "",
        mobile: "",
      },
      isEdit: false,

      // 表单验证规则
      rules: {
        name: {
          required: true,
          message: "请输入类型名称",
          trigger: "blur",
        },
        type: {
          required: true,
        },
        username: { required: true },
        password: { required: true },
        mobile: { required: true },
      },
      // 干部人员表单
      manDialog: false,
      manForm: {
        name: "",
        phone: "",
      },
    }
  },
  methods: {
    /*请求数据*/
    getData() {
      this.request({
        url: "/manager/area/areaPage",
        method: "get",
        params: {
          page: this.page,
          size: this.size,

          name: this.searchForm.name,
          status: this.searchForm.status,
        },
      })
        .then(res => {
          this.size = res.data.data.size
          this.page = res.data.data.page
          this.totalElements = Number(res.data.data.totalElements)
          this.totalElements = Number(res.data.data.totalElements)
          this.totalPages = res.data.data.totalPages

          this.tableData = res.data.data.content
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*更改单页数据数量*/
    handleSizeChange(size) {
      this.size = size
      this.getData()
    },

    /*页码跳转*/
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },

    /*启用/禁用*/
    handleEnabled(rowData) {
      const status = rowData.status === 1 ? 2 : 1
      this.request({
        url: "/manager/area/changeStatus",
        data: {
          uid: rowData.uid,
          status: status,
        },
        method: "post",
      })
        .then(res => {
          this.$message.success("操作成功")
          this.getData()
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*编辑*/
    handleEdit(rowData) {
      this.form = pick(rowData, [
        "uid",
        "name",
        "username",
        "mobile",
        "type",
        "password",
      ])
      this.isEdit = true
      this.dialogFormVisible = true
    },

    /*删除*/
    handleDelete(rowData) {
      this.$confirm("确认删除?")
        .then(() => {
          this.request({
            url: "/manager/area/deleteAreas",
            params: {
              uid: rowData.uid,
            },
            method: "DELETE",
          })
            .then(res => {
              this.$message.success("删除成功")
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch()
    },
    // 维护干部信息
    manManager(rowData) {
      this.manDialog = true
    },
    closeManDialog() {
      this.manDialog = false
      this.manForm = {
        uid: "",
        name: "",
        phone: "",
      }
    },
    addManDialog() {},

    /*dialog提交*/
    dialogConfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.request({
            url: "/manager/area/addOrUpdateAreas",
            data: {
              ...this.form,
            },
            method: "post",
          })
            .then(res => {
              this.getData()
              this.dialogCancel()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        }
      })
    },

    /*dialog取消*/
    dialogCancel() {
      this.dialogFormVisible = false
      this.isEdit = false
      this.$refs.form.resetFields()
      resetObject(this.form)
    },
  },
  mounted() {
    this.getData()
  },
}
</script>

<style scoped lang="scss"></style>
